import { createFileRoute } from "@tanstack/react-router";
import { ChangePasswordForm } from "@/features/auth/components/ChangePasswordForm";
import { AuthLayout } from "@/features/auth/components/AuthLayout";
import { useAuth } from "@/features/auth/hooks/useAuth";

export const Route = createFileRoute("/profile/change-password/")({
    component: ChangePasswordPage,
});

function ChangePasswordPage() {
    const { logout } = useAuth();

    const handleSuccess = () => {
        // Logout user after successful password change
        logout();
    };

    return (
        <AuthLayout>
            <ChangePasswordForm onSuccess={handleSuccess} />
        </AuthLayout>
    );
}
